export default __webpack_public_path__ + "static/desktop-1.5x-8f46a417db950c09957a6fc50e46eaa9.jpeg";